import { render, staticRenderFns } from "./moveMoney.vue?vue&type=template&id=b75eb256"
import script from "./moveMoney.vue?vue&type=script&lang=js"
export * from "./moveMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports